
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class StateDropdown extends Vue {
  @Prop()
  stateList?: Array<any>;

  @Prop()
  userState?: string;

  @Prop()
  isPreselected?: boolean;

  // Emits event with selected state as value
  selectState(state: string): void {
    this.$emit('stateSelected', state);
  }
}
